import React from 'react';
import styled from 'styled-components';

const SVG = styled.svg`
  path {
    fill: ${({ theme }) => theme.colors.accentGray04};
  }

  &.blue path {
    fill: ${({ theme }) => theme.colors.text05};
  }
`;

export const ViewIcon = (props) => (
  <SVG width="21" height="20" viewBox="0 0 21 14" {...props}>
    <g fill="none" fillRule="evenodd" transform="translate(-557 -175)">
      <path
        fillRule="nonzero"
        d="M10.5 14C4.082 14 .894 8.893.101 7.403c-.135-.252-.135-.554 0-.806C.894 5.107 4.082 0 10.5 0c6.418 0 9.605 5.107 10.399 6.597.135.252.135.554 0 .806C20.105 8.893 16.918 14 10.5 14zm.007-11.813c-2.657 0-4.81 2.155-4.81 4.813s2.153 4.813 4.81 4.813c2.656 0 4.81-2.155 4.81-4.813 0-1.276-.507-2.5-1.409-3.403s-2.126-1.41-3.401-1.41zm0 7.876c-1.691 0-3.062-1.371-3.062-3.063 0-1.691 1.371-3.062 3.062-3.062 1.69 0 3.06 1.37 3.06 3.062 0 1.692-1.37 3.063-3.06 3.063z"
        transform="translate(557 175)"
      />
    </g>
  </SVG>
);

export const ViewOffIcon = (props) => (
  <SVG width="21" height="20" viewBox="0 0 21 20" {...props}>
    <g fill="none" fillRule="evenodd" transform="translate(-558 -253)">
      <path
        fillRule="nonzero"
        d="M17.8 14.413c-.173.156-.433.146-.596-.022l-2.092-2.174c-.12-.126-.16-.314-.1-.48.66-1.832.229-3.895-1.102-5.279-1.331-1.383-3.317-1.831-5.081-1.147-.16.062-.341.022-.463-.104L6.97 3.755c-.067-.07-.095-.17-.073-.266.022-.096.09-.174.18-.205 1.105-.374 2.261-.563 3.424-.56 6.418 0 9.605 5.302 10.399 6.85.135.261.135.576 0 .837-.794 1.516-1.844 2.871-3.099 4.002zM2.375.266l17.496 18.182c.342.355.342.93 0 1.286-.34.355-.895.355-1.237 0L1.138 1.552c-.341-.355-.342-.93 0-1.286.342-.355.896-.355 1.237 0zm1.42 5.33l2.101 2.183c.121.126.16.313.1.48-.653 1.83-.22 3.887 1.107 5.267 1.329 1.38 3.31 1.83 5.071 1.153.16-.063.34-.022.461.103l1.394 1.449c.067.07.095.17.073.266-.022.096-.09.173-.18.204-1.105.374-2.26.563-3.422.56-6.418 0-9.605-5.303-10.399-6.85-.135-.261-.135-.576 0-.838.794-1.514 1.843-2.87 3.097-4 .174-.156.434-.146.597.022z"
        transform="translate(558 253)"
      />
    </g>
  </SVG>
);

export default ViewIcon;
